import { ComponentStore } from '@ngrx/component-store';
import { Injectable } from '@angular/core';

interface State {
  isVisibleOnLoading: boolean;
}

@Injectable()
export class PreLoaderStore extends ComponentStore<State> {
  constructor() {
    super({
      isVisibleOnLoading: false
    });
  }

  // updater
  public readonly showLoader = () =>
    this.patchState({ isVisibleOnLoading: true });

  public readonly hideLoader = () =>
    this.patchState({ isVisibleOnLoading: false });

  // selectors
  public readonly isVisibleOnLoading$ = this.select(
    state => state.isVisibleOnLoading
  );
}
